import gql from 'graphql-tag';

import { useMutation } from '@apollo/client';
import { REGION_FIELDS } from '../../fragments/fence/region';
import { CreateRegion, CreateRegionVariables } from '../../athena/types/CreateRegion';

export const CREATE_REGION = gql`
  mutation CreateRegion(
    $identifier: String
    $description: String
    $tagIdentifiers: [String!]
    $postalCodes: [String!]
    $geojsonGeom: String
    $state: OdProtosCommonState_State
    $organizationUuid: [String!]
    $createdByToken: String
  ) {
    fence {
      createRegion(
        input: {
          identifier: $identifier
          description: $description
          tagsIdentifiers: $tagIdentifiers
          postalCodes: $postalCodes
          geojsonGeom: $geojsonGeom
          state: $state
          organizationUuid: $organizationUuid
          createdByToken: $createdByToken
        }
      ) {
        region {
          ...RegionFields
        }
      }
    }
  }
  ${REGION_FIELDS}
`;

export const useCreateRegion = () => {
  return useMutation<CreateRegion, CreateRegionVariables>(CREATE_REGION);
};
